import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { buildInfo } from 'environments/version';

export interface AppInfo {
  appName: string;
  version: string;
  commit: string;
  branch: string;
  buildDate: string;
  /** 'dev' | 'homolog' | 'prod' | 'intranet' */
  environmentName: string;
  production: boolean;
  apiURL: string;
}

/**
 * Fonte única de versão/ambiente do front. Consome os dados gerados em
 * environments/version.ts (build) + environments/environment.ts (ambiente).
 */
@Injectable({ providedIn: 'root' })
export class AppInfoService {
  constructor(private http: HttpClient) {}

  get info(): AppInfo {
    const env: any = environment;
    return {
      appName: 'Infokaw',
      version: buildInfo.version,
      commit: buildInfo.commit,
      branch: buildInfo.branch,
      buildDate: buildInfo.buildDate,
      environmentName: env.name || (env.production ? 'prod' : 'dev'),
      production: env.production,
      apiURL: env.apiURL,
    };
  }

  /** true quando NÃO é produção — controla a exibição do badge de ambiente. */
  get isNonProd(): boolean {
    return this.info.environmentName !== 'prod';
  }

  /** Label curto do badge (DEV / HOMOLOG / INTRANET). */
  get envLabel(): string {
    return this.info.environmentName.toUpperCase();
  }

  /**
   * Build-Time do backend (lido do MANIFEST via /empresa/build).
   * Best-effort: devolve null em qualquer erro (rede/auth/offline).
   */
  getBackendBuildTime(): Observable<string | null> {
    return this.http.get<any>(`${environment.apiURL}/empresa/build?pass=info`).pipe(
      map(res => (res && (res['Build-Time'] || res['Implementation-Version'])) || null),
      catchError(() => of(null)),
    );
  }
}
